/**
 * Send Core Web Vitals to GA4 via gtag event.
 * Called from src/index.js after the app mounts.
 * Silently no-ops if window.gtag is not present.
 */
// Send all Core Web Vitals under ONE clear event ("web_vitals") with the metric
// carried as a parameter, instead of five cryptic top-level events
// (CLS / FID / FCP / LCP / TTFB). This declutters the GA4 event list while
// keeping full granularity — break "web_vitals" down by `metric_name`.
// (Register `metric_name` as an event-scoped custom dimension in GA4 to slice by it.)
const sendToGA4 = ({ name, delta, value, id, rating }) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'web_vitals', {
      metric_name:     name,   // CLS | FID | FCP | LCP | TTFB
      metric_id:       id,
      metric_value:    Math.round(name === 'CLS' ? delta * 1000 : delta),
      metric_rating:   rating, // good | needs-improvement | poor (when provided)
      event_category:  'Web Vitals',
      event_label:     name,
      non_interaction: true,
    });
  }
};

const reportWebVitals = (onPerfEntry) => {
  const handler = onPerfEntry instanceof Function ? onPerfEntry : sendToGA4;
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
